// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2r7jL","title":"ClientReferral_title__1gc2E","itemText":"ClientReferral_itemText__7-JjF"};